import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, MailIcon, InstagramIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-[#edf2e8] px-4 py-16 md:py-20" data-id="element-170" data-mp="1o5pzsb4apxxc">
      <div className="mx-auto max-w-3xl" data-id="element-171" data-mp="222dbxl4tkunu">
        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="rounded-3xl border border-brand-primary/35 bg-brand-cream-light p-8 text-center shadow-xl md:p-12" data-id="element-172" data-mp="221bvf151bfyq">
          <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-brand-accent/20" data-id="element-173" data-mp="14hh8s4ehnxzf">
            <ShieldCheckIcon className="h-11 w-11 text-brand-darker" aria-hidden="true" data-id="element-174" data-mp="1j6n7lr9ezm6s" />
          </div>
          <h2 className="mt-6 font-serif text-4xl leading-tight text-brand-darker md:text-5xl" data-id="element-175" data-mp="1ec0u9ijrvjk2">
            Garantía de 7 días, sin preguntas y sin vueltas.
          </h2>
          <div className="mt-6 space-y-4 text-lg leading-relaxed text-brand-darker/75" data-id="element-176" data-mp="lon2rzyufg7c">
            <p data-id="element-177" data-mp="oyqeiaqr5zk7">
              Tenés 7 días para entrar al material, revisar los tomos y aplicar
              las primeras herramientas con tranquilidad.
            </p>
            <p data-id="element-178" data-mp="yot6q8q1v9hh">
              Si sentís que no es lo que necesitabas, te devolvemos el{' '}
              <strong className="text-brand-darker" data-id="element-179" data-mp="12rg04e2dd2gs">100% de tu dinero</strong>.
              Sin formularios largos y sin drama.
            </p>
            <p data-id="element-180" data-mp="628e74xu8rcc">
              Ofrecemos esta garantía porque creemos que tu confianza vale más
              que cualquier venta.
            </p>
          </div>
          <div className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-3 text-sm font-medium text-brand-darker" data-id="element-181" data-mp="f0u1fde98ujg">
            <a href="mailto:soporte.mamasinkos@gmail.com" className="inline-flex items-center gap-2 hover:text-brand-accent" data-id="element-182" data-mp="k1hqvumu53bk">
              <MailIcon className="h-4 w-4" data-id="element-183" data-mp="1qg91iq1rg2is" /> soporte.mamasinkos@gmail.com
            </a>
            <a href="https://www.instagram.com/mamasiincaos?igsh=dnVnOHZ3M2VhY2hk&utm_source=qr" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 hover:text-brand-accent" data-id="element-184" data-mp="1ve0rvfmrbgkv">
              <InstagramIcon className="h-4 w-4" data-id="element-185" data-mp="3ngvdpjpzl8gk" /> @mamasiincaos
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}